<template lang="pug">
  div(v-if="installation && devices && schedules")
    //- Barra con los datos de una instalación
    .units__installations__bar
      .units__installations__name {{ installation.name }}
      .units__installations__action(
        v-if="!allDevicesWater"
        @click="addSchedule(installationID)")
        van-icon(name="more")

    //- Listado de dispositivos dentro de una instalación
    DeviceRow(
      v-for="(device, mac) in devices"
      :key="mac"
      :ACSMode="ACSMode"
      :installationID="installationID"
      :deviceSchedules="schedules[mac]"
      :mac="mac"
      :day="day"
      @updateSchedule="updateSchedule")
</template>

<script>
import DeviceRow from '@/components/Schedules/DeviceRow.vue';
import { mapGetters } from 'vuex';

export default {
  components: { DeviceRow },
  props: {
    /**
     * ID de la instalación
     */
    installationID: {
      type: String,
      required: true,
    },
    /**
     * Día de la semana seleccionado
     */
    day: {
      type: Number,
      required: true,
    },
    /**
     * Indica si la visualización es modo ACS
     */
    ACSMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getInstallation: 'unitsModule/getInstallation',
      getACSDevices: 'unitsModule/getACSDevices',
      getDevices: 'unitsModule/getDevices',
      getSchedules: 'unitsModule/getSchedules',
    }),

    /**
     * Devuelve los datos de una instalación
     */
    installation() {
      return this.getInstallation(this.installationID);
    },

    /**
     * Devuelve todos los dispositivos de una instalación
     */
    devices() {
      if (this.ACSMode) return this.getACSDevices(this.installationID);
      return this.getDevices(this.installationID);
    },

    /**
     * Devuelve todas las programaciones de una instalación
     */
    schedules() {
      return this.getSchedules(this.installationID);
    },

    /**
     * Las unidades de agua no tienen programaciones
     * indica si todas las unidades son de agua
     */
    allDevicesWater() {
      return Object.keys(this.devices).every(device => device.tai_th);
    },
  },
  methods: {
    /**
     * Añade una nueva programación
     */
    addSchedule(installationID) {
      this.$emit('addSchedule', { installationID, ACSMode: this.ACSMode });
    },

    /**
     * Edita una programación
     */
    updateSchedule(data) {
      this.$emit('updateSchedule', data);
    },
  },
};
</script>
